import { Routes } from '@angular/router';

import { AcceptEmailVerifyComponent } from '@shared/accept-email-verify/accept-email-verify.component';
import { PageNotFoundComponent } from '@app/pages/page-not-found/page-not-found.component';

export const routes: Routes = [{
  path: '',
  children: [{
    path: '',
    pathMatch: 'full',
    redirectTo: '/login'
  }, {
    path: '',
    loadChildren: './pages#PagesModule'
  }, {
    path: 'accept-email-verify/:id',
    component: AcceptEmailVerifyComponent
  }, {
    path: 'redirect',
    loadChildren: './shared/redirect/redirect.module#RedirectModule'
  }, {
    path: '404', component: PageNotFoundComponent
  }, {
    path: '**',
    redirectTo: '/404'
  }]
}];
